import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useDarkMode } from '../contexts/DarkModeContext';
import { MoonIcon, SunIcon } from './ui/Icons';
const DarkModeToggle = () => {
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const { t } = useTranslation();
    const label = isDarkMode ? t('darkMode.disable', 'Disable Dark Mode') : t('darkMode.enable', 'Enable Dark Mode');
    return (_jsx("button", { type: "button", className: "icon-btn dark-mode-toggle", onClick: toggleDarkMode, "aria-label": label, title: label, children: isDarkMode ? _jsx(SunIcon, { size: 19 }) : _jsx(MoonIcon, { size: 19 }) }));
};
export default DarkModeToggle;
